import { useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, Form, FormContext, Select } from 'dash-ui';
import { FormFields } from 'containers/alerts/AddAlertModal/constants/constants';
import { useGetMarketAreasQuery } from 'gql/generated.graphql';

function MarketSection() {
  const { t } = useTranslation(['forms', 'forms', 'pages']);
  const { formErrors, stateHandlers, formState } = useContext(FormContext);

  const { data: result } = useGetMarketAreasQuery({
    variables: {
      filter: {
        stateNames: formState?.state && [formState.state],
      },
      pagination: {
        allowLimit: false,
      },
      sort: {
        fieldName: 'name',
        sortOrder: 1,
      },
    },
  });

  const { marketAreas } = useMemo(
    () => ({
      marketAreas: result?.getMarketAreas?.collection || [],
    }),
    [result]
  );

  const marketOptions = useMemo(() => {
    return marketAreas.map(({ _id, name }) => ({
      value: _id,
      label: name,
    }));
  }, [marketAreas]);
  
  return (
    <>
      <Form.Group w="100%">
        <Form.Label>{t('labels.market')}</Form.Label>
        <Select
          w="100%"
          mr={3}
          placeholder={t('forms:placeholders.markets') || ''}
          isMulti
          onChanged={(_, value) => stateHandlers['markets'](value)}
          value={formState[FormFields.Markets]}
          options={marketOptions}
        />
      </Form.Group>
      <Flex>
        <Form.Feedback $errorType={formErrors[FormFields.Markets]?.type}>
          {formErrors[FormFields.Markets]?.message}
        </Form.Feedback>
      </Flex>
    </>
  );
}

export default MarketSection;
